// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"Course_PageHolder__3Cz-K"};